import { render, staticRenderFns } from "./CompanyContactsList.vue?vue&type=template&id=e4aa4104&scoped=true"
import script from "./CompanyContactsList.vue?vue&type=script&lang=js"
export * from "./CompanyContactsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4aa4104",
  null
  
)

export default component.exports